import React from 'react'
import spinnerGif from 'assets/images/gif/spinner.gif'
import css from './index.module.scss'

const Spinner = ({ center }) => <img src={spinnerGif} alt="loading" className={`${css.spinner} ${center && css.center}`} />

export default Spinner